export enum SecretKeys {
  crypto = 'crYptoP@$$#0Rd',
  recaptcha = '6LcRh-sfAAAAALBvGSKSRK5KuqDYieiyvv3FmtS5',
}
